import Vue from 'vue';
import Vuex from 'vuex';

import menuStore from '@Feature/Menu';
import quizStore from '@Feature/SkincareFinder';
import searchStore from '@Feature/Search';
import searchFiltersStore from '@Feature/SearchFilters';
import bvStore from '@Feature/RatingsAndReviews';
import skincareV2Store from '@Feature/Quiz';

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    menuStore: menuStore.menuStore,
    quizStore: quizStore.quizStore,
    searchFiltersStore: searchFiltersStore.searchFiltersStore,
    bvStore: bvStore.bvStore,
    searchStore: searchStore.searchStore,
    skincareV2Store: skincareV2Store.skincareV2Store
  }
});
